import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { BUSINESS } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#1C1917] text-[#E7E5E4]">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex flex-col leading-none mb-6">
            <span className="text-xl font-semibold tracking-tight text-white">Masaya Hospitality</span>
            <span className="text-[0.6rem] tracking-[0.24em] uppercase text-[#8A9A86] font-medium mt-1">Operated by Masaya Rental Homes LLC</span>
          </div>
          <p className="text-sm text-[#A8A29E] leading-relaxed max-w-xs font-light">
            {BUSINESS.tagline}. A family-owned company managing furnished homes for extended-stay
            professionals across the Austin metro.
          </p>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase text-[#8A9A86] mb-6">Explore</p>
          <ul className="space-y-3 text-sm">
            {[
              { to: "/properties", label: "Furnished Units" },
              { to: "/luxury-vacation-homes", label: "Vacation Homes" },
              { to: "/cleaning-services", label: "Cleaning Services" },
              { to: "/gallery", label: "Gallery" },
              { to: "/about", label: "About Us" },
              { to: "/owners", label: "Property Owners" },
              { to: "/faq", label: "FAQs" },
              { to: "/contact", label: "Contact" },
              { to: "/portal", label: "Portal Login" },
            ].map((l) => (
              <li key={l.to}>
                <Link data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} to={l.to} className="text-[#D6D3D1] hover:text-white transition-colors duration-300">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs tracking-[0.2em] uppercase text-[#8A9A86] mb-6">Get in touch</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a data-testid="footer-email" href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 text-[#D6D3D1] hover:text-white transition-colors duration-300">
                <Mail className="w-4 h-4 text-[#8A9A86]" strokeWidth={1.5} /> {BUSINESS.email}
              </a>
            </li>
          </ul>
          <div className="flex items-center gap-4 mt-6">
            <a data-testid="footer-instagram" href={BUSINESS.social.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full border border-[#44403C] flex items-center justify-center hover:border-[#8A9A86] hover:text-[#8A9A86] transition-colors duration-300">
              <Instagram className="w-4 h-4" strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#44403C] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-xs text-[#78716C]">© {new Date().getFullYear()} {BUSINESS.legalName}. All rights reserved.</p>
        <div className="flex items-center gap-6 text-xs text-[#78716C]">
          <Link data-testid="footer-privacy" to="/privacy" className="hover:text-white transition-colors duration-300">Privacy Policy</Link>
          <Link data-testid="footer-terms" to="/terms" className="hover:text-white transition-colors duration-300">Terms</Link>
          <Link data-testid="footer-portal-login" to="/portal" className="hover:text-white transition-colors duration-300">Portal Login</Link>
          <Link data-testid="footer-contact-bottom" to="/contact" className="hover:text-white transition-colors duration-300">Contact</Link>
          <span>{BUSINESS.city}</span>
        </div>
      </div>
    </div>
  </footer>
);
